import { Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from './components/layout'
import { DashboardPage } from './pages/dashboard'
import { AccountLayout, AccountPage, ActivityPage } from './pages/account'
import { BillingPage, AppBillingPage } from './pages/billing'
import { AppsPage } from './pages/apps'
import { ApiKeysPage } from './pages/api-keys'

// Keep legacy callback for OAuth flow
import { CallbackPage } from './pages/CallbackPage'

function App() {
  return (
    <Routes>
      {/* OAuth callback (public, no shell) */}
      <Route path="/callback" element={<CallbackPage />} />
      <Route path="/auth/callback" element={<CallbackPage />} />

      {/* Main app routes - wrapped in AppShell */}
      <Route element={<AppShell />}>
        {/* Dashboard */}
        <Route path="/" element={<DashboardPage />} />

        {/* Account section with sub-navigation */}
        <Route path="/account" element={<AccountLayout />}>
          <Route index element={<Navigate to="/account/profile" replace />} />
          <Route path="profile" element={<AccountPage />} />
          {/* Redirect old security route to unified profile */}
          <Route path="security" element={<Navigate to="/account/profile" replace />} />
          <Route path="activity" element={<ActivityPage />} />
        </Route>

        {/* Billing section */}
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/billing/apps/:appId" element={<AppBillingPage />} />

        {/* Apps section */}
        <Route path="/apps" element={<AppsPage />} />

        {/* API Keys section */}
        <Route path="/api-keys" element={<ApiKeysPage />} />
      </Route>

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
